import { render, staticRenderFns } from "./BunnyIcon.vue?vue&type=template&id=4a4e5d8f&scoped=true"
import script from "./BunnyIcon.vue?vue&type=script&lang=js"
export * from "./BunnyIcon.vue?vue&type=script&lang=js"
import style0 from "./BunnyIcon.vue?vue&type=style&index=0&id=4a4e5d8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4e5d8f",
  null
  
)

export default component.exports